import { render, staticRenderFns } from "./SapiaClubPricesList.vue?vue&type=template&id=30bd3056&scoped=true&"
import script from "./SapiaClubPricesList.vue?vue&type=script&lang=js&"
export * from "./SapiaClubPricesList.vue?vue&type=script&lang=js&"
import style0 from "./SapiaClubPricesList.vue?vue&type=style&index=0&id=30bd3056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd3056",
  null
  
)

export default component.exports